import React from 'react'
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import moment from 'moment'
import axios from 'axios'
import { request } from '../requests/request'
import appInfo from '../utils/appInfo'
import { Toast ,setDefaultConfig } from 'antd-mobile'
import { POST_TYPE } from '../constants/POST_TYPE'
import { API } from '../constants/API'
import { PATH } from '../constants/PATH'
import { version } from '../../package.json'
import { handleAxios } from './handleAxios'
import { antdLangMap } from '../utils/antdLangMap'

let init = (g) => {

  function handlePath () {
    let { pathname: path, origin } = window.location
    let index = path.indexOf('index.html')
    if (!(index > 0)) {
      index = path.indexOf('#')
    }
    return origin + path.slice(0, index)
  }

  let ROOT_PATH = handlePath()

  //  moment
  //  https://momentjs.com/
  moment.locale('zh-cn')

  // let toast = Toast
  const toast = {
    info: (content, duration = 2, afterClose) => Toast.show({ content, duration: duration * 1000, afterClose }),
    success: (content, duration = 2, afterClose) => Toast.show({
      icon: 'success',
      content,
      duration: duration * 1000,
      afterClose
    }),
    fail: (content, duration = 2, afterClose) => Toast.show({
      icon: 'fail',
      content,
      duration: duration * 1000,
      afterClose
    }),
    show: (content = '加载中', duration = 0) => Toast.show({ icon: 'loading', duration: duration * 1000, content }),
    loading: (content = '', duration = 0) => Toast.show({ icon: 'loading', duration: duration * 1000, content }),
    hide: Toast.clear
  }
  // Object.assign(toast, {
  //   show: (content = '加载中', duration = 0) => Toast.loading(content, duration)
  // })
  // toast.loading = (content = '加载中', duration = 0) => toast.loading(content, duration)

  // toast.config({ duration: 2 })

  Object.assign(g, {
    API,
    POST_TYPE,
    PATH,
    ROOT_PATH,
    toast,
    moment,
    axios
  })
  // g.toast.show = (content = '加载中', duration = 0) => Toast.loading(content, duration)
}

init(window)

let initialize = (g) => {
  let request = axios
  let utils = {
    request,
    moment,
    toast: Toast
  }
  Object.assign(g, { utils })
}
initialize(global)

@withTranslation()
@withRouter
class InitialApp extends React.PureComponent {
  constructor (props) {
    super(props)
    const { search } = props.location
    const { i18n } = props
    const urlParams = new URLSearchParams(search)
    // old[remove]
    handleAxios(window.axios, urlParams)
    // show app info
    // todo 要想办法把这个channelName给缓存起来,这个windows.appInfo和新的那一个又很突兀
    window.appInfo = {
      BASE_URL: axios.defaults.baseURL,
      VERSION: version,
      appChannelName: urlParams.get('channelName'),
      ...process.env
    }
    // handle lang
    const lang = urlParams.get('lang')
    const langSet = ['kr', 'hans', 'hant', 'hk', 'en']
    if (lang && langSet.includes(lang)) {
      console.log('change lang')
      setDefaultConfig({locale: antdLangMap(lang)})
      i18n.changeLanguage(lang).then()
    }

    //
    console.group(`app version: ${version}`, axios.defaults.baseURL)
    console.table(window.appInfo)
    console.groupEnd()
    if (urlParams.get('token')) {
      request.setToken(urlParams.get('token'))
    } else if (appInfo.buildEnv === 'development') {
      //
      // let token = 'eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcHAiLCJzdWIiOiJ7XCJhdXRob3JpdGllc1wiOltcIlJPTEVfVVNFUlwiXSxcImlkXCI6XCI4NDNcIixcInVzZXJuYW1lXCI6XCIxMzcwMDAwMDAwNVwifSIsImF1ZCI6IjEzNzAwMDAwMDA1IiwiaWF0IjoxNzE0MzgxMjg0fQ.cprSqJ0u7yRrv1xb_kpqlW65-fQIeup-31kDqvLF2zZ6p0qQsQJIaOfKDhMTazbEUOxss7BfxnVs99Jr4RaoGA'
      // 13700000005
      // let token = 'eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcHAiLCJzdWIiOiJ7XCJhdXRob3JpdGllc1wiOltcIlJPTEVfVVNFUlwiXSxcImlkXCI6XCI4NDNcIixcInVzZXJuYW1lXCI6XCIxMzcwMDAwMDAwNVwifSIsImF1ZCI6IjEzNzAwMDAwMDA1IiwiaWF0IjoxNzA1MDI2NzQ3fQ.ztnOFszmITVxN3r_VEDudfTCCIsBhtgxQIjOLV_v9LkqCvvpocE4SwQzcch2yydQEg5mERq88Oo-OUOPQxvKUA'
      // 13243875384
      // let token = 'eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcHAiLCJzdWIiOiJ7XCJhdXRob3JpdGllc1wiOltcIlJPTEVfVVNFUlwiXSxcImlkXCI6XCI4NzBcIixcInVzZXJuYW1lXCI6XCIxMzI0Mzg3NTM4M1wifSIsImF1ZCI6IjEzMjQzODc1MzgzIiwiaWF0IjoxNzA3MzU4MzQxfQ.oXUEHoxakvtkVoQJtyPfBhgstGzjUe1_Q16LU0Gc3N1DCeXfiaTWhwoR7pA4_TUGdVAEkLqnBpGQG2gQ7lSSnQ'
      // 13243875383
      // const token = 'eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcHAiLCJzdWIiOiJ7XCJhdXRob3JpdGllc1wiOltcIlJPTEVfVVNFUlwiXSxcImlkXCI6XCI4NzBcIixcInVzZXJuYW1lXCI6XCIxMzI0Mzg3NTM4M1wifSIsImF1ZCI6IjEzMjQzODc1MzgzIiwiaWF0IjoxNzA5NzE2OTcwfQ.0Cw9eWFrJnZcZYk-GhIOiQJPdV9PNzRo_upQ7dOgZ4NaT3kJ6nJiUf4dj1uCv0JLnLNcZbzbbLU3WAedvyXmDQ'
      // 156
      // const token = 'eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcHAiLCJzdWIiOiJ7XCJhdXRob3JpdGllc1wiOltcIlJPTEVfVVNFUlwiXSxcImlkXCI6XCI3ODRcIixcInVzZXJuYW1lXCI6XCIxNTYyMjIzODc3NVwifSIsImF1ZCI6IjE1NjIyMjM4Nzc1IiwiaWF0IjoxNzM1MDM0ODQ4LCJleHAiOjE3MzU0NjY4NDh9.Xrojwm58-hul_hB8vI_Fgx6L-TZZ3T7OYan5wceTpsZMwGrS2iZ4iWVajGQlgc57IJqubQUTTTE0Kwg-nlhOxg'
      // request.setToken(token)
    }
  }

  componentDidMount () {
    window.addEventListener('message', this.receiveMessage)
  }

  render () {
    // if (window.appInfo['REACT_APP_BUILD_ENV'] === 'development') {
    //   return <div>
    //     {this.props.children}
    //     <div style={{
    //       position: 'absolute',
    //       top: 0,
    //       right: 0,
    //       opacity: 0.2
    //     }}>{window.appInfo['REACT_APP_BUILD_ENV']} {version}</div>
    //   </div>
    // }
    return this.props.children
  }

  handleReceiveToken = token => {
    window.axios.setToken(token)
    window.location.reload()
  }

  receiveMessage = message => {
    if (message.data && (typeof message.data === 'string')) {
      let data = JSON.parse(message.data)
      switch (data['type']) {
        // 这代码是测试用的
        // case 'loginRequest':
        //   window.postMessage(JSON.stringify({
        //     type: 'receiveToken', token:
        //       'eyJhbGciOiJIUzUxMiJ9.eyJpc3MiOiJhcHAiLCJzdWIiOiJ7XCJhdXRob3JpdGllc1wiOltcIlJPTEVfVVNFUlwiXSxcImlkXCI6XCIxNzhcIixcInVzZXJuYW1lXCI6XCIxODMzOTg0Njk0NlwifSIsImF1ZCI6IjE4MzM5ODQ2OTQ2IiwiaWF0IjoxNTU2NDMzMzA1fQ.DE-VNOXL2IQ6VDEHWFdniooeowluaPD_QINFAPzTHI_mV7ii32Lt0rmH7YQAfXyU36Y9n79PaOLhb57u4pC2sg'
        //   }), '*')
        //   break
        case 'receiveToken':
          this.handleReceiveToken(data['token'])
          break
        default :
      }
    }
  }

}

export default InitialApp
